import styled from 'styled-components';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import useAccordionOpenState from 'ContentEditorUI/hooks/useAccordionOpenState';
import { jsx as _jsx } from "react/jsx-runtime";
export const TitleWrapper = styled.span.withConfig({
  displayName: "InpageSectionAccordion__TitleWrapper"
})([".hs-private.hs-private.hs-private &{font-size:14px;}"]);
const InpageSectionAccordion = ({
  children,
  title,
  type
}) => {
  const storageKey = `addSectionAccordion-${type}.isOpen`;
  function getInitialOpenState(storedOpenState) {
    return Boolean(storedOpenState && storedOpenState === 'true' || storedOpenState === null);
  }
  const {
    isOpen,
    handleOpenChange
  } = useAccordionOpenState({
    storageKey,
    getInitialOpenState
  });
  return /*#__PURE__*/_jsx(AccordionItem, {
    title: title,
    size: "small",
    marginBlockEnd: "500",
    titleTagName: "h5",
    open: isOpen,
    onOpenChange: handleOpenChange,
    removeContentPadding: true,
    "data-test-id": `add-module-group-${type}`,
    animate: false,
    children: children
  });
};
export default InpageSectionAccordion;